import messengerApiService from "../../../api/raily/messenger/messenger-api.service";
import {
  MessengerBillingPostRequest,
  MessengerCargoPostRequest,
  MessengerDelegationNotesPostRequest,
  MessengerDriverPostRequest,
  MessengerMileageNotesPostRequest,
  MessengerMileagePassengerPostRequest,
  MessengerRailyPostRequest,
  MessengerSharedPostRequest,
  MessengerSolvedDriverPostRequest,
  MessengerTaxiPostRequest,
} from "../../../api/raily/messenger/post/messenger-post.request";
import MessengerPostResponse from "../../../api/raily/messenger/post/messenger-post.response";
import MessengerPostBillingType from "../../../types/messenger-post-billing-type";
import MessengerPostChannel from "../../../types/messenger-post-channel";
import MessengerPostParams from "./messenger-post-params";

const create = (
  params: MessengerPostParams,
  abortSignal: AbortSignal,
): Promise<MessengerPostResponse>[] => {
  const promises = params.availableChannels.map((channel) => {
    switch (channel) {
      case MessengerPostChannel.BILLING: {
        const request: MessengerBillingPostRequest = {
          billingUuid: params.billingUuid ?? "",
        };

        if (params.billingType === MessengerPostBillingType.TAXI) {
          return messengerApiService().getTaxiBillingPosts(
            request,
            abortSignal,
          );
        } else {
          return messengerApiService().getCargoBillingPosts(
            request,
            abortSignal,
          );
        }
      }
      case MessengerPostChannel.CARGO: {
        const request: MessengerCargoPostRequest = {
          orderUuid: params.orderUuid ?? "",
        };

        return messengerApiService().getCargoPosts(request, abortSignal);
      }
      case MessengerPostChannel.DRIVER: {
        if (params.planEntryUuid) {
          const request: MessengerDriverPostRequest = {
            planEntryUuid: params.planEntryUuid,
          };

          return messengerApiService().getDriverPosts(request, abortSignal);
        }

        if (params.solvedOrderUuid) {
          const request: MessengerSolvedDriverPostRequest = {
            solvedOrderUuid: params.solvedOrderUuid,
          };

          return messengerApiService().getSolvedDriverPosts(
            request,
            abortSignal,
          );
        }

        return Promise.reject();
      }
      case MessengerPostChannel.RAILY: {
        const request: MessengerRailyPostRequest = {
          orderUuid: params.orderUuid ?? "",
        };

        return messengerApiService().getRailyPosts(request, abortSignal);
      }
      case MessengerPostChannel.SHARED: {
        const request: MessengerSharedPostRequest = {
          orderUuid: params.orderUuid ?? "",
        };

        return messengerApiService().getSharedPosts(request, abortSignal);
      }
      case MessengerPostChannel.TAXI: {
        const request: MessengerTaxiPostRequest = {
          orderUuid: params.orderUuid ?? "",
          taxiCorporationUuid: params.taxiCorporationUuid ?? "",
        };

        return messengerApiService().getTaxiPosts(request, abortSignal);
      }
      case MessengerPostChannel.MILEAGE_PASSENGER: {
        const request: MessengerMileagePassengerPostRequest = {
          mileageUuid: params.orderUuid ?? "",
        };

        return messengerApiService().getMileagePassengerPosts(
          request,
          abortSignal,
        );
      }
      case MessengerPostChannel.MILEAGE_NOTES: {
        const request: MessengerMileageNotesPostRequest = {
          mileageUuid: params.orderUuid ?? "",
        };

        return messengerApiService().getMileageNotesPosts(request, abortSignal);
      }
      case MessengerPostChannel.DELEGATION_NOTES: {
        const request: MessengerDelegationNotesPostRequest = {
          delegationUuid: params.orderUuid ?? "",
        };

        return messengerApiService().getDelegationNotesPost(
          request,
          abortSignal,
        );
      }
    }
  });

  return promises;
};

const messengerPostParamsFactory = { create };

export default messengerPostParamsFactory;
